module.exports = __webpack_public_path__ + "static/media/goblin_chief_mounted_circle.65dc2ee6.svg";